import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import ProductBox from './ProductBox';
import { readWishlist } from './wishlist';
import { _ProductDetail } from './Products';

const WishlistPage: React.FC = () => {
  const [items, setItems] = useState<_ProductDetail[]>([]);
  const [loading, setLoading] = useState(true);
  const [loggedIn, setLoggedIn] = useState(false);

  const load = async () => {
    setLoading(true);
    let backendIds: number[] | null = null;
    try {
      const meRes = await fetch('/api/me');
      const me = await meRes.json();
      const isLogged = !!me?.data?.logged_in;
      setLoggedIn(isLogged);
      if (isLogged) {
        const wlRes = await fetch('/api/wishlist');
        const wl = await wlRes.json();
        if (wl?.data?.ids && Array.isArray(wl.data.ids)) {
          backendIds = wl.data.ids;
        }
      }
    } catch {}

    const localIds = readWishlist();
    const ids = backendIds !== null
      ? Array.from(new Set([...backendIds, ...localIds]))
      : localIds;

    if (ids.length === 0) { setItems([]); setLoading(false); return; }
    try {
      const r = await fetch(`/api/products-by-ids?ids=${ids.join(',')}`);
      const d = await r.json();
      setItems(d.data || []);
    } catch {}
    setLoading(false);
  };

  useEffect(() => {
    load();
    const onChange = (e: Event) => {
      const detail = (e as CustomEvent<number[]>).detail || readWishlist();
      setItems((prev) => prev.filter((p) => detail.includes(p.id)));
    };
    window.addEventListener('wishlist-changed', onChange);
    return () => window.removeEventListener('wishlist-changed', onChange);
    /* eslint-disable-next-line */
  }, []);

  return (
    <div className="archive wishlist-archive">
      <div className="wishlist-header">
        <h1 className="wishlist-title">Oblíbené</h1>
        <Link to="/product" className="wishlist-back">← Pokračovat v nákupu</Link>
      </div>
      {!loggedIn && items.length > 0 && (
        <p className="wishlist-hint">
          Tip: Po přihlášení se vaše oblíbené produkty synchronizují napříč zařízeními.
        </p>
      )}
      {loading ? (
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '60px 20px' }}>
          <div className="spinner" aria-hidden="true" />
          <div style={{ marginTop: 14, color: '#7f7b98', fontSize: 14 }}>Načítám oblíbené…</div>
        </div>
      ) : items.length === 0 ? (
        <div className="wishlist-empty">
          <p>Zatím tu nemáte žádné oblíbené produkty.</p>
          <Link to="/product" className="btn">Procházet střihy</Link>
        </div>
      ) : (
        <div className="products">
          <ProductBox item={items} productID={0} handleProductItem={() => {}} />
        </div>
      )}
    </div>
  );
};

export default WishlistPage;
